export default __webpack_public_path__ + "static/media/396407.66c877a0.png";